module.exports = __webpack_public_path__ + "img/dcd@2X.7aee615b.png";